import { render } from "./dsAiVue.vue?vue&type=template&id=8b2a3586&scoped=true"
import script from "./dsAiVue.vue?vue&type=script&lang=js"
export * from "./dsAiVue.vue?vue&type=script&lang=js"

import "./dsAiVue.vue?vue&type=style&index=0&id=8b2a3586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2a3586"]])

export default __exports__